import { call, put } from 'redux-saga/effects';
import QRAuthApi from '../apis/QRAuthApi';
import QRVAlUE_ACTION_TYPES from '../actionTypes/QrAuth';

export const subscription = ({ subscription }) => subscription.remoteService;

/**
 * @name post QRvalue
 * @description post method
 */
export function* getQrAuthValue() {
  try {
    // const subscribed = yield select(subscription);
    // if (subscribed) {
    const response = yield call(QRAuthApi.post);
    const payload = response || {};
    yield put({
      type: QRVAlUE_ACTION_TYPES.POST.SUCCESS,
      payload,
    });
    // }
  } catch (error) {
    yield put({
      type: QRVAlUE_ACTION_TYPES.POST.ERROR,
      error,
    });
  }
}
